/* eslint-disable arrow-parens */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Tabs, Tab } from '@mui/material'
import { makeStyles } from '@mui/styles'

// components
import WelcomeBanner from '../home/components/dashboard/components/welcomeBanner'
import { fetchReviews, fetchOpenCampiagn, fetchClosedCampiagn } from '../../store/actions/reviews'
import { getCampaignReviewCallStatus, getAccountOpenCampaigns } from '../../store/reducers/reviewSlice'
import LoadingSpinner from '../../components/loadingSpinner'
import { getUserId, isReviewer } from '../../helpers/user'
import ReviewsList from './components/ReviewsList'
import TabPanel from '../../components/tabPanel'

// styles
import styles from './reviews.module.scss'

const useStyles = makeStyles({
  root: {
    '& .MuiBox-root': {
      padding: '0 0',
    },
  },
})

function reviews() {
  const { t } = useTranslation()
  const userId = getUserId()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  // TODO - Remove below call when the review page add to the menu
  if (isReviewer()) {
    useEffect(() => {
      dispatch(fetchReviews(userId))
      dispatch(fetchOpenCampiagn())
      dispatch(fetchClosedCampiagn())
    }, [dispatch, userId])
  }

  const handleTabChange = (_event, index) => {
    setSelectedTabIndex(index)
  }

  const reviewCallStatus = useSelector(getCampaignReviewCallStatus)
  const openReviews = useSelector(state => state.reviews.openReviews)
  const openCampiagns = useSelector(getAccountOpenCampaigns)
  const closedCampaigns = useSelector(state => state.reviews.closedCampaigns)

  const openCount = Array.isArray(openCampiagns) ? openCampiagns.length : 0
  const closedCount = Array.isArray(closedCampaigns) ? closedCampaigns.length : 0

  if (reviewCallStatus === 'loading') {
    return <LoadingSpinner />
  }

  return (
    <div
      style={{
        backgroundColor: '#f4f3f1',
        minHeight: '100vh',
        width: '100vw',
      }}
    >
      <WelcomeBanner />
      <div className={styles.container}>
        <h1 className={styles.title}>{t('my-reviews-title')}</h1>
        <Tabs
          sx={{ backgroundColor: '#F5F5F5', justifyContent: 'left' }}
          TabIndicatorProps={{
            sx: {
              top: '0',
              backgroundColor: '#EB1700',
              height: '2px',
              zIndex: '2',
            },
          }}
          className={styles.tabContainer}
          value={selectedTabIndex}
          onChange={handleTabChange}
        >
          <Tab
            label={t('open-review-count', { count: openCount })}
            className={styles.tabLabel}
          />
          <Tab
            label={t('closed-review-count', { count: closedCount })}
            className={styles.tabLabel}
          />
        </Tabs>
        <TabPanel
          className={classes.root}
          value={selectedTabIndex}
          index={0}
          sx={{ width: '50%' }}
        >
          <ReviewsList
            areLoading={reviewCallStatus}
            items={openCampiagns}
            openReviews={openReviews}
          />
        </TabPanel>
      </div>
    </div>
  )
}

export default reviews
